import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import {CurrentsDataSourceComponent} from './../../views/appviews/currents-data-source/currents-data-source.component';
// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';


import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';


import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
// 

import {  IFilterUI, Column, IFilter, GridComponent, GroupSettingsModel, RowDataBoundEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { Brand } from 'src/app/shared/models/brand.model';
import { JobSubject } from 'src/app/shared/models/jobSubject.model';


import { CommandColumnService, DetailRowService, ExcelExportService, FilterSettingsModel, ITreeData, PdfExportService, ToolbarItems, ToolbarService, TreeGridAllModule, TreeGridComponent } from '@syncfusion/ej2-angular-treegrid';
// import {  sampleData } from '../jobs-grid/jsontreegredidata';
// import { projectData } from '../jobs-grid/jsontreegredidata';

import {FilterService, PageService, SortService } from '@syncfusion/ej2-angular-treegrid'
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';

@Component({
  selector: 'app-staff-performance-metrics-tree-grid-staff',
  templateUrl: './staff-performance-metrics-tree-grid-staff.component.html',
  styleUrls: ['./staff-performance-metrics-tree-grid-staff.component.scss'],
  providers: [PageService,  SortService,
    FilterService, DetailRowService, CommandColumnService, ExcelExportService,
    ToolbarService, PdfExportService ]
})
export class StaffPerformanceMetricsTreeGridStaffComponent implements OnInit {

  public data: Object[] = [];

  public tree_data: Object[] = [];
  public pageSettings2: Object;

  @ViewChild('treegrid')
  public treegrid: TreeGridComponent;

  @ViewChild('treegrid2')
  public treegrid2: TreeGridComponent;

  @ViewChild('treegrid+jobs')
  public treegrid_jobs: TreeGridComponent;

  @ViewChild('treegrid')
  public treeGridObj?: TreeGridComponent;


@Input() brand_id?; 
@Input() job_status_code?
@Input() assigned_agent?


   // setup as observable?
   @Input() item_id?: any; // impliments on changes. // Base set to Job_ID
   @Input() item_data?: any; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = null;
   @Input() item_brand_id? = null;
   @Input() item_subject_id? = null;
   @Input() item_subject_number? = '';
   
   @Input() show_buttons? = 'no'; // yes | no
   @Input() item_title? = '';
   @Input() widget_size? = 'full'; // side | abstract | full | dashboard


   public searchSettings: Object;
   public toolbar: string[];



 // Grid Vars
//  public data: DataManager;
 public data_subjects: DataManager;
 public pageSettings: Object;
 public pageOptions = { pageSize: 100 }; 
 public filterOptions: FilterSettingsModel;
 public formatOptions: Object;
 // public filterOptions: FilterSettingsModel;
 public filter : IFilter;
 public toolbarOptions: ToolbarItems[];
 @ViewChild('grid')
 public grid: GridComponent;
 public groupOptions: GroupSettingsModel;
 public templateOptionsDate: IFilterUI;
 public elem1: HTMLElement;
 public datePickerObj: DatePicker;
 subjects_urgent: any;
 formatoptions: { type: string; format: string; };
 dateFormat: string;
 sortOptions: object

 initialPage: { pageSize: number; };
 open_jobs_count: any;
  all_router_details: string;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  subjects_urgent_table: any;


  today = new Date();
  today_ISO = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
  today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
  action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
  action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison


  public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' };
  client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  job_status_run: Object;
  combo_model: Brand;
  search_model: JobSubject;
  job_status_data: any;
  brands_client: any;
  sent_brand_id: any;
  brand_users: any;
  brand_users_data: Object;
  job_types: any;
  tree_data_a: Object[] = []; // important!
  subjects_urgent_tree: any;
  public filterSettings?: Object;

  constructor( private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService
   ) {

 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

     }

  ngOnInit() {

    this.data = sampleData;

 
    this.searchSettings = { hierarchyMode: 'Parent' };
    // this.toolbar = ['Search', 'ExcelExport'];
    this.toolbar = [ 'ExcelExport', 'PdfExport'];

    // this.tree_data = sampleData;
    // this.tree_data_a = projectData;
    // this.pageSettings2 = { pageSize: 50 };

    this.filterSettings = { type: 'Menu', hierarchyMode: 'Parent' };
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };


    this.tree_data = sampleData;
    this.tree_data_a = projectData;
    this.pageSettings2 = { pageSize: 150 };
  
    // Turnded off to see if increases speed
    // this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);

// end date filter options
    // End Grid Options
  }

  ngOnChanges(changes) {
   

   
    if (changes.brand_id) {
      // deal with asynchronous Observable result
    // this.brand_id = changes.brand_id.currentValue;


    // this.getJobStatusNames();
    // this.getJobTypes()
    // this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
    // this.search_model = new JobSubject();

    // // set searh defaults
    // this.search_model.limit = 200;
    //   this.search_model.sort_by = 'desc';
    //   this.search_model.order_by = 'job_id'


    // this.getBrandsComboBoxClients(this.combo_model);





    
    //  this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);
    //  this.getBrandJobsTableDataGrid_TreePost(this.brand_id, this.job_status_code, this.assigned_agent, this.search_model);

            //   // Grid Options
            //   this.toolbarOptions = ['Search'];
            //   this.initialPage = { pageSize: 40 };
            //   this.filterOptions = {
            //      type: 'Menu'
            //   };

            //   // showGroupedColumn : true, showToggleButton: true, showUngroupButton: true
            // //  this.groupOptions = { columns: ['job_id'], allowReordering: false, showGroupedColumn : true, showToggleButton: false, showUngroupButton: true, showDropArea: true }; // sets auto grouping for the grid
            //  this.groupOptions = { columns: ['job_id'], allowReordering: true}; // sets auto grouping for the grid // turn off for 10000
            // //  this.groupOptions = { disablePageWiseAggregates: true, allowReordering: true}; // sets auto grouping for the grid // turn off for 10000

            //   this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
            //   this.dateFormat = 'dd/MM/yyyy hh:mm a';
            //   this.filter = { params: { format: this.dateFormat } };
            //   this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };  // turn off for 10000
            //   // this.sortOptions;
}


    

  }
;



// Setup the SyncFusion GRID

// Sort comparer function 
// KEY the key when it comes to order ing by ID>.. needs to be a number format not STRING!@@@@@@
sortComparer(reference: string, comparer: string) { 
  // This will be triggered for comparing each value with the reference value 
  // This can be customized to compare the values as per your need and return the corresponding result 

  let r: number = +reference
  let c: number = +comparer
  
  if (r < c) { 
    console.log('reference ' + reference)  
    console.log('comparer ' + comparer)  
    return -1; 
      
  } 
  if (r > c) { 
    console.log('reference gtr ' + reference)  
    console.log('comparer grt' + comparer)  
      return 1; 
  } 
  //was 0
  return 0; 
} 


toolbarClickTree(args: Object | any) : void {
  if (args['item'].text === 'Excel Export') {
      this.treeGridObj?.excelExport();
  }
  if (args['item'].text === 'PDF Export') {
    (this.treeGridObj as TreeGridComponent).pdfExport();
}
}

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }


}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}



jobLink(job_id) {
  this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
}

jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}

subjectEdit(subject_id){
  this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
}


refreshGrid(){ // refresh the databutton
  this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);
  this.grid.refresh();
};





getBrandJobsTableData(brand_id) {
  this._demoService.getBrandJobsTableData(brand_id).subscribe(
    data => { this.subjects_urgent = data;
      this.open_jobs_count = this.subjects_urgent.length;

      this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subjects_urgent = DataUtil.parse.parseJson(data); 
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  ); }

  getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
    this._demoService.getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent).subscribe(
      data => { this.subjects_urgent = data;

        this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);

      let res = data[0];

        // removes all words with length of > 6
       // const result = this.subjects_urgent.filter(word => this.subjects_urgent.length > 6);

       if (this.gfunc.sessionUserLevel === '9' ) { //client - remove these columns
       // let result_filter = this.subjects_urgent.filter(subject => this.subjects_urgent.job_type_id);
       // res.filter( e => this.subjects_urgent.allocated_to);
       // send results back to array.
      // this.subjects_urgent = result_filter;
       }


        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
     
      // the orginal output.... sept 2024  
        this.subjects_urgent = DataUtil.parse.parseJson(data); 
      
      
      
        // console.log("Done loadng USER");
       // console.log(this.users);
  
  
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }




    getBrandJobsTableDataGrid_TreePost(brand_id, job_status_code, assigned_agent, search_model) {
      this.subjects_urgent_tree = null; // clear.
      this._demoService.getBrandJobsTableDataGrid_TreePost(brand_id, job_status_code, assigned_agent, search_model).subscribe(
        data => { this.subjects_urgent = data;
  
          this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
  
        let res = data[0];
  
          // removes all words with length of > 6
         // const result = this.subjects_urgent.filter(word => this.subjects_urgent.length > 6);
  
         if (this.gfunc.sessionUserLevel === '9' ) { //client - remove these columns
         // let result_filter = this.subjects_urgent.filter(subject => this.subjects_urgent.job_type_id);
         // res.filter( e => this.subjects_urgent.allocated_to);
         // send results back to array.
        // this.subjects_urgent = result_filter;
         }
  
  
          this.open_jobs_count = this.subjects_urgent.length;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
        // the orginal output.... sept 2024  
          this.subjects_urgent_tree = DataUtil.parse.parseJson(data); 
        
        
        
          // console.log("Done loadng USER");
         // console.log(this.users);
    
    
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }



// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    //console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

};




// End Grid Items and Setup





private getJobStatusNames() {
  this._demoService.getJobStatusNames()
    .subscribe(
      res => {
        this.job_status_run = res
        this.job_status_data = res
      },
      err => console.error(err.status)
    );
}


getBrandsComboBoxClients(combo_model) {
  this.combo_model.brand_type_id = 2;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_client = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



// drop down action
sendBrandID(brand_report_id) {
this.sent_brand_id = brand_report_id;

// reset the form field first.
// this.model.brand_report_user_id = '';
// this.brand_users = '';
    // empty the array incase there are no users to prevent prev selection
    this.brand_users = null;

if(brand_report_id >= 1) {
// this.getBrandUsers(brand_report_id); // updates the selected brand_ ID....
this._demoService.getBrandUsersByLevel(brand_report_id, 9).subscribe(
 data => { this.brand_users = data;


   this.brand_users_data = data;


   let res = data[0];
},
 err =>  console.error(err),
 // () => console.log('done loading Trace Types')
);



}


}




// head styles
rowBound(args: RowDataBoundEventArgs | any) {
  if (!args.data.hasChildRecords) {
    //Here apply the background color of child rows
    args.row.style.background = '#f5f5f5';
  } else {
    //Here apply the background color of parent rows
    args.row.style.background = '#fff';
  }

  // if(args.data.deviceAlertRules.length == 0) { }
      //here hide which parent row has no child records -- hides parent row with not child.
      // args.row.querySelector('td').innerHTML=' '; 
      // args.row.querySelector('td').className = 'e-customizedExpandcell'; // 

 
      if (!(args.data as ITreeData).hasChildRecords) {
       // (args.row as HTMLElement).style.backgroundColor = 'green';
    }

}



queryCellInfo(args: QueryCellInfoEventArgs) {
  if (!(args.data as ITreeData).hasChildRecords){
      if ((args.cell as HTMLElement).classList.contains("e-unboundcell")) {
          ((args.cell as HTMLElement).querySelector('.e-unboundcelldiv') as HTMLElement).style.display = "none";
      }
  }
}




public expandAll() 
{ 
    this.treeGridObj.expandAll(); 
} 
public collapseAll() 
{ 
    this.treeGridObj.collapseAll(); 
} 




}
